import { isEmpty } from 'lodash';
import { useReducer, useEffect } from 'react';
import { connect } from 'react-redux';
import { selectEndorsements, selectGLLimit, selectLimitDamagePremRented } from '../../../selectors/application';
import { endorsementsMap } from '../../AddOns/addOnQuestionMap';
import { SectionHeader } from '../styles';
import { EndorsementEnum } from '../../../types/enums';
import AddOnsServices from './AddOnsServices';
import AdditionalCoverages from './AdditionalCoverages';
import Packages from './Packages/Packages';
import AdditionalInsureds from './AdditionalInsureds';
import EndorsementsSummary from '../Endorsements/EndorsementsSummary';
import { useFeatureFlags } from '../../../toggle_tools/featureFlagTools';

interface AddOnSummaryProps {
  endorsements: EndorsementsInterface;
  glLimit?: number;
  limitDamagePremRented?: number;
  hasBOPorGL?: boolean;
  shouldShowPackages?: boolean;
}

const AddOnsSummary = ({
  endorsements,
  glLimit,
  limitDamagePremRented,
  hasBOPorGL,
  shouldShowPackages,
}: AddOnSummaryProps) => {
  const [cachedEndorsements] = useReducer((state: any, action: any) => (action != null ? action : state), endorsements);
  const cachedEndorsementKeys = Object.keys(cachedEndorsements);
  const { isEndorsementsRefactorEnabled } = useFeatureFlags();

  useEffect(() => {
    if (glLimit === 2_000_000) {
      delete endorsements[EndorsementEnum.liquorLiabilityEndorsement];
      delete cachedEndorsements[EndorsementEnum.liquorLiabilityEndorsement];
    }
  }, [glLimit]);

  const shouldRenderAddOns =
    !isEmpty(cachedEndorsements) &&
    cachedEndorsementKeys.reduce((accum: boolean, addedEndorsement: string) => {
      if (accum) return true;

      return Boolean(endorsementsMap[addedEndorsement] && cachedEndorsements[addedEndorsement]);
    }, false);

  if (!shouldRenderAddOns && !limitDamagePremRented && !hasBOPorGL && !shouldShowPackages) return null;

  return (
    <>
      <SectionHeader>Your Add Ons</SectionHeader>
      {hasBOPorGL && <AddOnsServices />}
      <AdditionalInsureds />
      {isEndorsementsRefactorEnabled ? <EndorsementsSummary /> : <AdditionalCoverages />}
      {shouldShowPackages && <Packages />}
    </>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  endorsements: selectEndorsements(state) || { additionalInsureds: [] },
  glLimit: selectGLLimit(state),
  limitDamagePremRented: selectLimitDamagePremRented(state),
});

export default connect(mapStateToProps)(AddOnsSummary);
